module.exports = __webpack_public_path__ + "static/media/more-grey-icon.fdb25f0b.svg";